import { Action, Mutation } from "../types";
import { Message } from "@/modules/staff/objects/conversation/Message";
import { openCouponWindow } from "@/store/storeUtil";

export default {
  [Action.hidePromptCompleteService]({ commit }: any) {
    commit(Mutation.SET_DISPLAY_PROMPT_COMPLETE_SERVICE, false);
  },
  [Action.clickSystemMessage](context: any, message: Message) {
    const sysMessage = message.contents.filter((e: any) => e.sys_msg)[0].sys_msg;
    const isCoupon = sysMessage.type === "coupon_message";
    if (isCoupon) {
      openCouponWindow(sysMessage);
    }
  },
  [Action.tenantId]({ commit }: any, data: any) {
    commit(Mutation.SET_TENANT_ID, data);
  },
  async [Action.clickSubMenu]({ commit, dispatch }: any, selectedSubMenu: any) {
    //
  },
  [Action.setSelectedMenu]({ commit }: any, selectedMenu: any) {
    commit(Mutation.SET_SELECTED_MENU, selectedMenu);
    // Add selectedMenu to LocalStorage
    // const selectedMenuString = JSON.stringify(selectedMenu);
    // localStorage.setItem("selectedMenu", selectedMenuString);
  },
  [Action.onNotifyCreateSandbox]({ commit }: any, data: any) {
    // アクションを実行してstoreでサブスクライブできるようにするだけなので、ここでは何もしない
  },
  [Action.onNotifyApplySandbox]({ commit }: any, data: any) {
    // アクションを実行してstoreでサブスクライブできるようにするだけなので、ここでは何もしない
  },
};
